import { DrawerHeader } from "../../../../components/drawer/drawer-header";
import { Icon } from "../../../../components/icon/icon";
import {
  FormHeaderTextarea,
  FormTextarea,
  FormFieldName,
  // FormSelect
} from "../../../../components/form/form";
import { memo, useState } from "react";
import { useSiteEdit } from "./site-edit.hook";
import { Drawer } from "../../../../components/drawer/drawer";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
// import DropdownFilters from "../../../../components/dropdown-filters/dropdown-filters";
import TagsSelect from "../../../../components/tags-select/tags-select";
import { StopOutlined, CheckOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/layouts/common/delete-modal";

const SiteCardInside = memo(
  ({
    site,
    subjects,
    users,
    close,
    editMode,
    createSite,
    updateSite,
    cancelEditing,
    deleteSite,
    toEditMode,
    onlyView,
    toggleActive
  }) => {
    const { t } = useTranslation();
    const control = useSiteEdit({
      site,
      createSite,
      updateSite,
      cancelEditing,
      close,
    });
    const [confirmToggleOpen, setConfirmToggleOpen] = useState(false);

    return (
      <>
        <DrawerHeader
          title={<p className="life-fact-title">{t("site_management.title")}</p>}
          isEditing={editMode}
          onEdit={onlyView ? undefined : toEditMode}
          onClose={close}
          onSave={control.save}
          saveTestID="site-save"
          onCancel={control.cancel}
          menu={
            onlyView
              ? undefined
              : {
                  items: [
                    {
                      label: "Delete",
                      icon: (
                        <Icon
                          name={"delete"}
                          style={{ marginRight: 8, marginLeft: -4 }}
                        />
                      ),
                      onClick: deleteSite,
                    },
                    {
                      label: control?.isActive ? 'Deactivate' : 'Activate',
                      "data-testid": "site-toggle-active",
                      icon: control?.isActive ? (
                        <StopOutlined style={{ marginRight: 8, marginLeft: -4 }} />
                      ) : (
                        <CheckOutlined style={{ marginRight: 8, marginLeft: -4 }} />
                      ),
                      onClick: () => setConfirmToggleOpen(true),
                    }
                  ]
                }
          }

        />
        <div style={{ paddingBottom: 24 }} >
          <FormHeaderTextarea
            data-testid="site-name"
            readonly={!editMode}
            placeholder={"Name"}
            defaultValue={control.name.value}
            onChange={control.name.update}
            maxLength={100}
          />
        </div>
        <Form.Item name="description">
          <FormFieldName text="Description:" />
          <FormTextarea
            readonly={!editMode}
            placeholder={"Description"}
            defaultValue={control.description.value}
            onChange={control.description.update}
            maxLength={1000}
            style={{
              fontSize: 14,
              padding: 0
            }}
          />
        </Form.Item>
        <Form.Item name={"subjects"} initialValue={control.subjects.value.map((c) => c.id )}>
          <FormFieldName text="Subjects:" />
          <div style={{ marginLeft: 11 }}>
            <TagsSelect
              options={(subjects || []).map((c) => ({
                value: c.id,
                label: c.displayId,
                key: c.id,
              }))}
            defaultValue={control.subjects.value
              .slice()
              .sort((a, b) => (a.displayId || '').localeCompare(b.displayId || ''))
              .map((c) => ({
                value: c.id,
                label: c.displayId,
                key: c.id,
              }))}
              onChange={control.subjects.onChange}
              onCreate={control.subjects.onCreate}
              readonly={!editMode}
              placeholder="+ Add Subject"
              noMarginLeft={true}
              isEditing={!editMode}
            />
          </div>
        </Form.Item>
        <Form.Item name={"users"} initialValue={control.users.value.map((c) => c.id )}>
          <FormFieldName text="Users:" />
          <div style={{ marginLeft: 11 }}>
            <TagsSelect
              options={(users || []).map((c) => ({
                value: c.id,
                label: c.email,
                key: c.id,
              }))}
            defaultValue={control.users.value
              .slice()
              .sort((a, b) => (a.email || '').localeCompare(b.email || ''))
              .map((c) => ({
                value: c.id,
                label: c.email,
                key: c.id,
              }))}
              onChange={control.users.onChange}
              onCreate={control.users.onCreate}
              readonly={!editMode}
              placeholder="+ Add User"
              noMarginLeft={true}
              isEditing={!editMode}
            />
          </div>
        </Form.Item>
        <DeleteModal
          title={control.name.value}
          question={`Are you sure you want to ${control?.isActive ? 'deactivate' : 'activate'} this task?`}
          handleOk={() => {
            toggleActive(control);
            setConfirmToggleOpen(false);
          }}
          handleCancel={() => setConfirmToggleOpen(false)}
          isModalOpen={confirmToggleOpen}
        />
      </>
    );
  }
);

const SiteCard = ({
  site,
  subjects,
  users,
  isOpen,
  close,
  editMode,
  createSite,
  updateSite,
  deleteSite,
  toEditMode,
  cancelEditing,
  onlyView,
  toggleActive
}) => {
  return (
    <Drawer open={isOpen} size={800} closable={false} onClose={close}>
      <div style={{ paddingBottom: 48 }}>
        {isOpen && (
          <SiteCardInside
            site={site}
            subjects={subjects}
            users={users}
            createSite={createSite}
            close={close}
            cancelEditing={cancelEditing}
            updateSite={updateSite}
            deleteSite={deleteSite}
            toEditMode={toEditMode}
            editMode={editMode}
            onlyView={onlyView}
            toggleActive={toggleActive}
          />
        )}
      </div>
    </Drawer>
  );
};

export default SiteCard;
